const orderBasketSelectEvent = () => {
	const selectBlockEvent = document.querySelector('[data-block="select-event"]');

	try{
		selectBlockEvent.addEventListener('click', (e)=>{
			let target = e.target;

			console.log(target.tagName)
		});
	}catch(e){}
}

export default orderBasketSelectEvent;